import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../dto/dto.js';

export class CustomInfo extends DataModel {
  static readonly TYPE_ID: string = 'fb6224248d3e4545bad204b438fa3e5e';

  private constructor(
    public readonly title: string,
    public readonly body: string,
  ) {
    super();
  }

  get $typeId() {
    return CustomInfo.TYPE_ID;
  }

  static create(options: {
    title: string,
    body: string,
  }): CustomInfo {
    return new CustomInfo(
        options.title,
        options.body,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): CustomInfo {
    return new CustomInfo(
        MapUtils.get<string>(map, 'title'),
        MapUtils.get<string>(map, 'body'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'title': this.title,
      'body': this.body,
    };
  }

  clone(): this {
    return new CustomInfo(
        this.title,
        this.body,
    ) as this;
  }

  isSame(other: CustomInfo): boolean {
    if(other === this) {
      return true;
    }

    return other.title === this.title &&
        other.body === this.body;
  }
}

export class CustomInfoBuilder extends DataModelBuilder<CustomInfo> {
  build(context: SerializationContext, map: SerializedData): CustomInfo {
    return CustomInfo.fromMap(context, map);
  }
}
